export const COMPANION_BRIEFING_ALLOWED_SEND_HOURS = [
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
] as const;

export type CompanionBriefingAllowedSendHour =
  (typeof COMPANION_BRIEFING_ALLOWED_SEND_HOURS)[number];

export type CompanionBriefingPreferences = {
  briefingEnabled: boolean;
  localSendTime: CompanionBriefingAllowedSendHour;
  emailBriefingConsent: boolean;
  pushBriefingConsent: boolean;
  updatedAt: string | null;
  hasPreference: boolean;
};

export type CompanionBriefingPreferenceRow = {
  briefing_enabled: boolean | null;
  local_send_time: string | null;
  email_briefing_consent: boolean | null;
  push_briefing_consent: boolean | null;
  updated_at: string | null;
};

const DEFAULT_SEND_TIME: CompanionBriefingAllowedSendHour = "06:00";

export function defaultCompanionBriefingPreferences(): CompanionBriefingPreferences {
  return {
    briefingEnabled: false,
    localSendTime: DEFAULT_SEND_TIME,
    emailBriefingConsent: false,
    pushBriefingConsent: false,
    updatedAt: null,
    hasPreference: false,
  };
}

export function isCompanionBriefingAllowedSendHour(
  value: string,
): value is CompanionBriefingAllowedSendHour {
  return COMPANION_BRIEFING_ALLOWED_SEND_HOURS.includes(
    value as CompanionBriefingAllowedSendHour,
  );
}

export function normaliseCompanionBriefingSendHour(
  value: string | null | undefined,
): CompanionBriefingAllowedSendHour | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  const match = trimmed.match(/^(\d{2}):00(?::00)?$/);
  if (!match) return null;
  const hour = `${match[1]}:00`;
  return isCompanionBriefingAllowedSendHour(hour) ? hour : null;
}

export function normaliseCompanionBriefingPreferenceRow(
  row: CompanionBriefingPreferenceRow | null | undefined,
): CompanionBriefingPreferences {
  if (!row) return defaultCompanionBriefingPreferences();

  return {
    briefingEnabled: row.briefing_enabled === true,
    localSendTime:
      normaliseCompanionBriefingSendHour(row.local_send_time) ?? DEFAULT_SEND_TIME,
    emailBriefingConsent: row.email_briefing_consent === true,
    pushBriefingConsent: row.push_briefing_consent === true,
    updatedAt: row.updated_at ?? null,
    hasPreference: true,
  };
}
